import { useEffect, useRef, useState } from 'react';
import dynamic from 'next/dynamic';
import { useTranslation } from 'next-i18next';
import styles from '@features/cms/components/collections/VideosBlock/VideosBlock.styles';
import VideoPlayer from '@components/Video/VideoPlayer';
import { IVideoBlock, IVideosBlock } from '@features/cms/typescript';
import Heading from '@components/Heading/Heading';
import theme from '@styles/theme';
import Button from '@components/Button/Button';
import useIntersect from '@hooks/useIntersect';
import { useResponsive } from '@features/responsive';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';
type PropsType = {
  data: IVideosBlock;
  isFirst?: boolean;
};
const DynamicVideoModal = dynamic(() => import('@components/VideoModal/VideoModal'), {
  ssr: false
});
const VideosBlock = ({
  data,
  isFirst = false
}: PropsType) => {
  const {
    t
  } = useTranslation('common');
  const [playVideoCount, setPlayVideoCount] = useState(-1);
  const [videoToPlay, setVideoToPlay] = useState('');
  const [modalVideoTitle, setModalVideoTitle] = useState('');
  const [isOpenModal, setIsModalOpen] = useState(false);
  const {
    blocks,
    code
  } = data;
  const {
    isNarrowerThanTablet
  } = useResponsive();
  const ref = useRef<HTMLDivElement | null>(null);
  const entry = useIntersect(ref, {
    rootMargin: '-100px',
    threshold: isNarrowerThanTablet as boolean ? 0 : 0.5,
    onlyOnce: true
  });
  useEffect(() => {
    if (entry?.isIntersecting && playVideoCount === -1) setPlayVideoCount(0);
  }, [entry]);
  const handleVideoPlayBlock = () => {
    setPlayVideoCount(playVideoCount < blocks.length - 1 ? playVideoCount + 1 : 0);
  };
  const handlePlayVideoModal = (video: string, title: string) => {
    setIsModalOpen(true);
    setVideoToPlay(video);
    setModalVideoTitle(title);
  };
  return <section id={code} sx={styles.vidoeBlockSection} ref={ref} data-cy={code} data-testid="videos-block">
      {blocks.map((block: IVideoBlock, index) => <div sx={styles.vidoeBlock(blocks.length)} key={block.itemId}>
          <div sx={styles.videoBlockContent}>
            {block.header && <Heading h={isFirst && !index ? 1 : 4} headingType={4} pb={isNarrowerThanTablet ? 16 : 24} mobile color={theme.rawColors.neutralWhite}>
                {block.header}
              </Heading>}
            {block.mainVideo && <Button variant="outlined" variantColor="white" size="small" onClick={() => handlePlayVideoModal(block.mainVideo, block.header)} cy={`${code}-seeMovie-${block.itemId}`}>
                {t('seeMovie')}
              </Button>}
          </div>
          {block.previewVideo && <VideoPlayer video={block.previewVideo} playVideo={playVideoCount === index || playVideoCount !== -1 && isNarrowerThanTablet as boolean} isEndFunc={handleVideoPlayBlock} poster={block.previewImage ?? undefined} loop={blocks.length === 1 || isNarrowerThanTablet as boolean} priority={isFirst} alt={block.header} />}
          {!block.previewVideo && block.previewImage && <ResponsiveImage sx={styles.image} image={block.previewImage} alt={block.header} />}
        </div>)}
      {videoToPlay && isOpenModal && <DynamicVideoModal active={isOpenModal} closeModalFunc={setIsModalOpen} video={videoToPlay} videoTitle={modalVideoTitle} />}
    </section>;
};
export default VideosBlock;